import React, { useEffect, useState } from "react";
import { Route, Switch } from 'react-router-dom'

import './LayouSubUser.scss'

import SubUsers from "./SubUsers/SubUsers";
import RegisterSubUser from "./RegisterSubUser/RegisterSubUser";
import VerifyPIN from "./VerifyPIN/VerifyPin";
import { useRouter } from "../../hooks/router";

import { decrypt,crypt } from "../Util/util";
import Loading from "../Loading/Loading";

export default function LayoutSubUsers({ isGuest, appSettings }) {
    const token = decrypt('token', localStorage.getItem("token"))
    const router = useRouter()

    const [user, setUser] = useState('')
    const [autoSigningIn, setAutoSigningIn] = useState(
        (router.pathname === '/subusers' || router.pathname === '/subusers/verify') &&
        !!sessionStorage.getItem('auto_signing_in')
    )

    useEffect(() => {
        if (!token) router.push('/auth')
    }, [])

    useEffect(() => {
        if (!autoSigningIn) return
        const interval = setInterval(() => {
            if (!sessionStorage.getItem('auto_signing_in')) {
                setAutoSigningIn(false)
            }
        }, 100)
        return () => clearInterval(interval)
    }, [autoSigningIn])

    const callBackUser = (e) => {
        setUser(e)
        localStorage.setItem('user', crypt('user', JSON.stringify(e)))
    }

    return (
        <div id={'subusers'} style={{ backgroundImage: `url('${localStorage.getItem('background_image')}')` }}>
            {autoSigningIn ? <Loading /> :
            <Switch>
                <Route exact path={'/subusers'}>
                    <SubUsers callBackUser={callBackUser} appSettings={appSettings }/>
                </Route>
                <Route path={'/subusers/create-subuser'}>
                    <RegisterSubUser />
                </Route>
                <Route path={'/subusers/verify'}>
                    <VerifyPIN user={user} />
                </Route>
            </Switch>
            }
        </div>
    )
}